// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderLocation_wrapper__8pNsb","right-section":"OrderLocation_right-section__2fuOq","left-section":"OrderLocation_left-section__2qARG"};